<template>
  <section class="mt-4">
    <template v-if="orders === null">
      <loader/>
    </template>
    <template v-else>
      <template v-if="orders.length === 0 && queryData.page === 0">
        <notification classname="alert-info" body="message.no_data"/>
      </template>
      <template v-else>
        <div class="card" 
             :class="{'border border-danger' : order.declined_order_data && order.status === 0 && order.selected_professional_id != 0}"
             v-for="(order, index) in orders" :key="order.id">
          <ul class="list-unstyled mb-0">
            <li class="card-body">
              <router-link :to="conditionOrder(order)" class="text-order">
                <div class="row">
                  <div class="col-9 col-lg-8 p-0">
                    #{{ order.order_code }}
                    -
                    <span v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span>
                    <img src="/static/img/ic_badge_photo.png"
                         height="24"
                         class="ml-1" v-if="order.sent_photo_status === 1">
                  </div>
                  <div class="col-3 col-lg-4 text-right p-0">
                    <span v-if="!order.service_request" v-html="$options.filters.orderStatus(order)"></span>
                  </div>
                </div>
                <div class="row mt-3 align-items-end">
                  <div class="col-9 col-lg-8 p-0">
                    <div class="float-left">
                      <template v-if="order.professional === null && order.selected_professional === null">
                        <img src="https://beneat.co/static/img/unknown.png" class="rounded-circle message-user-img">
                      </template>
                      <template v-else-if="order.professional">
                        <div class="professional-picture-box">
                          <professional-picture :professional="order.professional"
                                                :imgClass="'message-user-img'"
                                                :imgSize="36"/>
                        </div>
                      </template>
                      <template v-else>
                        <div class="professional-picture-box">
                          <professional-picture :professional="order.selected_professional"
                                                :imgClass="order.declined_order_data && order.status === 0 ? 'message-user-img border border-danger' : 'message-user-img'"
                                                :imgSize="36"/>
                        </div>
                      </template>
                    </div>
                    <div class="float-left ml-3">
                      <div v-if="order.user_place">{{ order.user_place.place_name }}</div>
                      <div class="text-order-date">
                        <span v-if="order.cleaning_date">{{ order.cleaning_date | shortDate }}</span>
                        <span v-else>{{ $t('message.my_reservations.booking_date_not_specified') }}</span>
                      </div>
                      <div>
                        <template v-if="order.service_id === 1">
                          <span v-if="order.cleaning_date">
                            {{ order.cleaning_date | onlyTime }} • {{ order.work_hour }} {{ $tc('message.hour', order.work_hour) }}
                          </span>
                          <span v-else>
                            {{ order.work_hour }} {{ $tc('message.hour', order.work_hour) }}
                          </span>
                        </template>
                        <template v-else-if="order.order_service_items && order.order_service_items.length">
                          <span v-if="order.cleaning_date">{{ order.cleaning_date | onlyTime }} •</span>
                          {{ $t('message.service_item.qty') }} {{ getServiceItemsQty(order.order_service_items) }} 
                        </template>
                        <template v-else>
                          <span v-if="order.cleaning_date">{{ order.cleaning_date | onlyTime }}</span>
                          <span v-if="order.work_hour"> • {{ globalState.services[order.service_id] | multiLangName }}</span>
                        </template>
                        <span v-if="$options.filters.orderAdditionalHours(order)">
                           {{ order | orderAdditionalHours }}
                        </span>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="col-3 col-lg-4 text-right p-0">
                    <span class="text-orange" v-if="order.subscription_id">
                      <i class="fal fa-calendar-alt"></i> {{ $t('message.subscription.title') }}
                    </span>
                    <span class="text-orange" v-if="order.package_id">
                      <i class="fal fa-layer-group"></i> {{ order.package.package_type | multiLangName }}
                    </span>
                    <span class="text-orange" v-if="order.host_id">
                      <i class="fal fa-bed"></i> {{ $t('message.my_reservations.for_host') }}
                    </span>
                    <span class="text-orange" v-if="!order.package_id && order.is_no_datetime_booking && order.status < 1">
                      {{ $t('message.booking.new_booking.booking_type_flexible') }}
                    </span>
                  </div>
                </div>

                <!-- Service request information -->
                <div class="pt-3" v-if="order.service_request">
                  <div>
                    <i class="fal fa-map-marker-alt"></i>&nbsp;&nbsp;{{ order.service_request.building_address }}
                  </div>
                  <div class="pt-2" v-if="order.service_request.payment_status === 0">
                    <i class="fal fa-file-alt -status-new"></i>&nbsp;&nbsp;{{ $t('message.service_request.service_request_document') }}
                  </div>
                </div>

                <div class="row" v-if="order.status < 2">
                  <div class="col-12 p-0">
                    <!--- Waiting for service provider confirm the booking -->
                    <template v-if="order.paid_status === 1 && order.cleaning_date && !order.confirm_cleaning_date && !order.declined_order_data">
                      <hr>
                      <div class="text-order-notification">
                        <span class="bullet-notification">
                          <i class="fas fa-circle -status-pending"></i>
                        </span>
                        {{ $t('message.my_reservations.no_confirm_cleaning_datetime') }}
                      </div>
                    </template>

                    <!--- Bank transfer unpaid notification -->
                    <template v-if="(order.payment_method === 'bank_transfer' || order.payment_method === 'promptpay') && !order.has_bank_transferred">
                      <hr>
                      <div class="text-order-notification">
                        <span class="bullet-notification">
                          <i class="fas fa-circle"></i>
                        </span>
                        {{ unpaidBankTransferNotification(order) }}
                      </div>
                    </template>

                    <!--- Professional declined order -->
                    <template v-if="order.declined_order_data && order.status === 0 && order.selected_professional_id === 0">
                      <hr>
                      <div class="text-order-notification">
                        <span class="bullet-notification">
                          <i class="fas fa-circle"></i>
                        </span>
                        {{ $t('message.my_reservations.finding_new_cleaner') }}
                      </div>
                    </template>

                    <template v-if="order.revise_datetime_data || displayAdditionalHoursNotification(order)">
                      <hr v-if="order.revise_datetime_data || displayAdditionalHoursNotification(order)">
                      <!--- Revise Data -->
                      <div class="text-order-notification" v-if="order.revise_datetime_data">
                        <span class="bullet-notification">
                          <i class="fas fa-circle"></i>
                        </span>
                        <span v-if="order.revise_datetime_data.sender_type === 'user'">
                          {{ $t('message.my_reservations.you_want_to_change_date_time') }}
                        </span>
                        <span v-else>
                          {{ $t('message.my_reservations.cleaner_want_to_change_date_time') }}
                        </span>
                      </div>
                      <!--- Additional Hours Data -->
                      <div class="text-order-notification" v-if="displayAdditionalHoursNotification(order)">
                        <span class="bullet-notification">
                          <i class="fas fa-circle"></i>
                        </span>
                        <span>{{ displayAdditionalHoursNotification(order) }}</span>
                      </div>
                    </template>

                    <!-- Declined Order Data -->
                    <div class="text-order-notification"
                         v-if="order.status === 0 && order.declined_order_data && order.selected_professional_id > 0">
                      <hr>
                      <span class="bullet-notification">
                        <i class="fas fa-circle -status-alert"></i>
                      </span>
                      <span class="-status-alert">
                        {{ $t('message.declined_booking.cleaner_declined_booking') }}
                      </span>
                      <div class="-status-alert mt-1">
                        - {{ order.declined_order_data | declinedReason }}
                      </div>
                    </div>

                    <!--- Pre-booking professional selection -->
                    <template v-if="order.pre_booking_professionals && order.status === 0">
                      <hr>
                      <div class="d-flex justify-content-start align-content-center text-order-notification">
                        <div>
                          <img src="/static/img/switch_professional.svg">
                        </div>
                        <div class="px-2">
                          {{ $t('message.booking.switch_professional.offer_pre_booking_professionals') }}
                        </div>
                        <div>
                          <span v-for="professional, index in order.pre_booking_professionals">
                            <img class="rounded-circle" 
                                :class="[index === 0 ? 'img-pre-booking-professional-first' : 'img-pre-booking-professional-other']"
                                :src="professional.full_picture" 
                                width="24">
                          </span>
                        </div>
                      </div>
                    </template>

                    <!-- Job status -->
                    <div class="text-order-notification" v-if="order.status === 1 && $options.filters.professionalJobStatus(order, false)">
                      <hr>
                      <div v-html="$options.filters.professionalJobStatus(order, false)"></div>
                    </div>
                  </div>
                </div>

                <!-- Service request status -->
                <template v-if="order.service_request">
                  <hr>
                  <div class="text-order-notification">
                        <span class="bullet-notification-yellow">
                          <i class="fas fa-circle -status-pending"></i>
                        </span>
                    {{ order.service_request.service_request_status | multiLangName }}
                  </div>
                </template>

                <template v-if="order.status === 2 && order.cancel === 0">
                  <div class="row">
                    <div class="col-12 p-0">
                      <div class="d-flex justify-content-start align-items-center mt-3" v-if="!order.is_received_order && !order.order_report_issue">
                        <div class="flex-fill">
                          <i class="fas fa fa-circle fa-sm text-info"></i>&nbsp;{{ $t('message.received_order.please_accept') }}
                        </div>
                        <div class="flex-fill">
                          <button class="btn btn-block btn-info"
                                @click.prevent="openReceivedOrderModal(index, order.id)">
                            {{ $t('message.button.received_order') }}
                          </button>
                        </div>
                      </div>
                      
                      <div class="d-flex justify-content-start align-items-center mt-3" v-else>
                        <div class="-status-accepted" v-if="order.is_received_order && order.is_reviewed">
                          <i class="fas fa fa-circle fa-sm"></i>&nbsp;{{ $t('message.my_reservations.reviewed') }}
                        </div>
                        <div class="text-right flex-fill">
                          <button class="btn btn-success" v-if="(order.is_received_order || order.order_report_issue) && !order.is_reviewed && order.review_days > 0"
                                  @click.prevent="openReviewModal(index, order.id, order.professional)">
                            {{ $t('message.my_reservations.give_a_review') }}
                          </button>
                          <button class="btn btn-outline-info" 
                                  @click.prevent="repeatBooking(order)" 
                                  v-if="!order.package_id && !order.subscription_id && !order.claimed_from">
                            {{ $t('message.button.repeat_booking') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

              </router-link>
            </li>
          </ul>
        </div>
        <div class="text-center">
          <button class="btn btn-outline-info btn-block"
                  :disabled="state.isFetching"
                  @click="fetchOrders"
                  v-if="state.isMore">
            {{ $t(isLoadMore) }}
          </button>
        </div>
      </template>
    </template>
    <!-- Review Modal -->
    <review-modal ref="reviewModal"/>
    <!-- Received Order Modal -->
    <received-order-modal ref="receivedOrderModal"/>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Loader from '../loader/Loader'
import Notification from '../partials/Notification'
import ReviewModal from './components/ReviewModal'
import ReceivedOrderModal from './components/ReceivedOrderModal'
import ProfessionalPicture from '../professional/components/ProfessionalPicture'
import orderHelpers from '../../helpers/orderHelpers'
import userEventLogHelpers from '../../helpers/userEventLogHelpers'
import moment from 'moment-timezone'

export default {
  props: {
    status: String
  },
  components: {
    ProfessionalPicture,
    Loader,
    Notification,
    ReceivedOrderModal,
    ReviewModal
  },
  data () {
    return {
      queryData: {
        page: 0,
        user_id: null,
        status: this.$route.params.status
      }
    }
  },
  computed: {
    ...mapState('auth', ['isLineLoggedIn']),
    ...mapGetters({
      globalState: 'globalVal/getState',
      isLoadMore: 'order/isLoadMore',
      orders: 'order/getOrders',
      state: 'order/getState',
      user: 'auth/getUser'
    })
  },
  methods: {
    repeatBooking (order) {
      // Generate repeat booking data
      orderHelpers.repeatBooking(order)
      // Save repeat booking log
      userEventLogHelpers.logEvent('repeat_booking', {
        order_id: order.id
      })
      this.$router.push('/booking/start?step=2')
    },
    unpaidBankTransferNotification (order) {
      const expireTime = moment().add(order.bank_transfer_expire_hours, 'hours').format('HH:mm')
      if (order.payment_method === 'bank_transfer') {
        return this.$i18n.t('message.payment_method.unpaid_bank_transfer', {time: expireTime})
      } else if (order.payment_method === 'promptpay') {
        return this.$i18n.t('message.payment_method.unpaid_bank_promptpay', {time: expireTime})
      }
    },
    conditionOrder (order = null) {
      // ถ้ามี Service Request = เป็นงาน Big Cleaning
      if (order.service_request) {
        return { name: 'Service Request Detail', params: { id: order.service_request.id } }
      } else {
        return { name: 'My Reservation', params: { id: order.id } }
      }
    },
    fetchOrders () {
      this.queryData.page++
      this.$store.dispatch('order/LOAD_ORDER_LIST', this.queryData)
    },
    initialData (status) {
      this.queryData.page = 0
      this.queryData.user_id = this.user.id
      this.queryData.status = status
      this.$store.commit('order/SET_EMPTY_ORDER')
      this.$store.dispatch('order/LOAD_ORDER_LIST', this.queryData)
    },
    openReviewModal (index, orderId, professional) {
      this.$refs.reviewModal.setOrderData(index, orderId, professional.id, professional.full_picture, professional.full_name)
      this.$refs.reviewModal.showReviewModal(true)
    },
    openReceivedOrderModal (index, orderId) {
      this.$refs.receivedOrderModal.setOrderData(index, orderId)
      this.$refs.receivedOrderModal.showReceivedOrderModal(true)
    },
    firstName (professionalName) {
      return this.$options.filters.firstName(professionalName)
    },
    getServiceItemsQty (orderServiceItems) {
      let count = 0
      orderServiceItems.forEach(item => {
        count += item.quantity
      })
      return count
    },
    displayAdditionalHoursNotification (order) {
      let message = null
      let orderAdditionalHours = null
      const bookMoreHours = order.book_more_hours
      if (bookMoreHours && bookMoreHours.length > 0) {
        orderAdditionalHours = bookMoreHours[0]
      }
      if (orderAdditionalHours && orderAdditionalHours.status === 0) {
        const senderType = orderAdditionalHours.sender_type
        if (senderType === 'user') {
          switch (orderAdditionalHours.payment_method) {
            case 'credit_card':
              message = this.$i18n.t('message.my_reservations.booking_additional_hours')
              break
            case 'promptpay':
              if (orderAdditionalHours.paid_status === 1) {
                message = this.$i18n.t('message.my_reservations.booking_additional_hours')
              }
              break
            case 'bank_transfer':
              message = this.$i18n.t('message.bank_transfer.complete_bank_transfer')
              break
          }
        } else {
          if (!orderAdditionalHours.payment_method) {
            message = this.$i18n.t('message.my_reservations.provider_request_additional_hours')
          } else if (orderAdditionalHours.payment_method && orderAdditionalHours.payment_method === 'bank_transfer') {
            message = this.$i18n.t('message.my_reservations.complete_bank_transfer')
          }
        }
      }
      return message
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/order/Orders.vue